import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DropdownLists } from './../../core/helpers/dropdown-lists/dropdown-lists';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAfiliado, IUser, IValidataUser } from './../../core/models/user/user';
import { InformationFormatting } from './../../core/helpers/information-formatting/information-formatting';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { RoutingPath } from './../../configs/routing-path';
import { UserService } from './../../core/services/user/user.service';
import { CryptojsService } from 'src/app/core/services/cryptojs/cryptojs.service';
import { ModalService } from 'src/app/core/services/modal/modal.service';
import { ModalVariadoService } from 'src/app/core/services/modal-variado/modal-variado.service';

@Component({
    selector: 'app-validate-user',
    templateUrl: './validate-user.component.html',
    styleUrls: ['./validate-user.component.scss'],
    standalone: false
})
export class ValidateUserComponent implements OnInit {

 @Input() accion : string;
  @ViewChild('btnConsultar', {static: true}) btnConsultar : ElementRef;
  validateUserForm: FormGroup;
  companyData: IUser;
  afiliadoData: IAfiliado;
  public inicio = '';
  validation = true;
  affiliation = false;
  processing = false;
  noAffiliateCompany = false;
  documentTypePerson = [];
  public urlActual = '';
  docIsSelect = false;
  numDocIsFill=false;
  @Input() individualQuery = false;
  @Input() afiliationOneToOne = false;
  @Input() analyticsModel: {
    event: string,
    category: string,
    action: string,
    label: string,
    EstadoSubsidio?: string
  } =  {
      "event": "ga_event",
      "category": "Informacion Trabajadores",
      "action": "PTEC-Consulta individual",
      "label": "Continuar",
    }
  @Output() afiliadoDataEvent = new EventEmitter<Partial<IAfiliado>>();
  @Input() isAfiliadoDataEvent = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute,
    private _storage: LocalStorageService,
    private _userService: UserService,
    private _cryptojsService:CryptojsService,
    private _modalVariadoService: ModalVariadoService
  ) {
    this.validateUserForm = this._formBuilder.group({
      idTypePerson: ['', Validators.required],
      idPerson: ['', [Validators.required]],
      idTypeEmployer: ['', Validators.required],
      idEmployer: ['', [Validators.required, Validators.minLength(6), Validators.pattern('^[0-9]*$')]],
    });
  }

  ngOnInit() {
    this.urlActual = this._router.url;
    const pathFormularioAfiliacion = 'afiliacion-individual/inicio';
    const esFormularioAfiliacion = this.urlActual.includes(pathFormularioAfiliacion);
    this.documentTypePerson = esFormularioAfiliacion ? DropdownLists.documentPerson.filter(tipo => tipo.value != 'CO1P' && tipo.value != 'CO1L' && tipo.value != 'CO1T' ): DropdownLists.documentPersonWorker.filter(tipo => tipo.value != 'CO1P' && tipo.value != 'CO1L' && tipo.value != 'CO1T'&& tipo.value != 'CO1V' );
    this.companyData = this._storage.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this.validateUserForm.get('idTypeEmployer').setValue(InformationFormatting.returnNameDocumentCompany(this.companyData.docTypeCompany));
    this.validateUserForm.get('idEmployer').setValue(this.companyData.docNumberCompany + this.companyData.checkDigit);
    this.validateUserForm.get('idTypeEmployer').markAsTouched();
    this.validateUserForm.get('idEmployer').markAsTouched();
    this.inicio = RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.affiliation.path;

    if (this.urlActual === '/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path) {
      this.individualQuery = true;
    }

  }

  get v() { return this.validateUserForm.controls; }

  changeSelectDocumentType(tid: any) {
    this.validateUserForm.get('idPerson').setValue('');
    this.docIsSelect = true;
    if (tid === 'CO1C') {
      this.validateUserForm.get('idPerson')
        .setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]);
    } else if (tid === 'CO1T' || tid === 'CO1L') {
      this.validateUserForm.get('idPerson')
        .setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(11), Validators.pattern('^[0-9]*$')]);
    } else if (tid === 'CO1D' || tid === 'CO1P') {
      this.validateUserForm.get('idPerson')
        .setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(15), Validators.pattern('^[a-zA-Z0-9]*$')]);
    } else if (tid === 'CO1E') {
      this.validateUserForm.get('idPerson')
        .setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(7), Validators.pattern('^[0-9]*$')]);
    } else if (tid === 'CO1V') {
      this.validateUserForm.get('idPerson')
        .setValidators([Validators.required, Validators.minLength(15), Validators.maxLength(15), Validators.pattern('^[a-zA-Z0-9]*$')]);
    } else if (tid === 'CO1W') {
      this.validateUserForm.get('idPerson')
        .setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(8), Validators.pattern('^[0-9]*$')]);
    }
  }

  public validateUser(user: IValidataUser) {
    this.processing = true;
    this._userService.validateUser(user,this.afiliationOneToOne)
      .pipe(
        map((response) => {
          this.processing = false;
          
          if (response.code.code === 200) {

            if (this.isAfiliadoDataEvent) {
              this.afiliadoDataEvent.emit( response.body.afiliado );
            }

            /**
             * Verifico si la url actual es de afiliacion uno a uno
             */
            if (this.urlActual === '/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path) {
              this.afiliadoData = response.body.afiliado;
              this.validateUserForm.get('idTypePerson').setValue('');
              this.validateUserForm.get('idPerson').setValue('');
              this.validateUserForm.get('idTypePerson').markAsUntouched();
              this.validateUserForm.get('idPerson').markAsUntouched();
              this.validation = false;
              this.affiliation = true;
              /**
               * Valido si la url actual es consulta de informacion trabajadores
               */
            } else if (this.urlActual === '/' + RoutingPath.appRouting.components.workers_information.path + '/' + RoutingPath.appRouting.components.workers_information.pages.consult_worker.path) {
              this._storage.stringifyItem(environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION, response.body.afiliado);
              this._router.navigate(['/' + RoutingPath.appRouting.components.workers_information.path + '/' + RoutingPath.appRouting.components.workers_information.pages.query_filter.path + '/' + user.idTypePerson + '/' + user.idPerson], { relativeTo: this._route });
              this._storage.setItem(environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION_CRP, this._cryptojsService.encrypt(response.body));
              /**
               * Valido si la url actua es certificado consulta trabajador
               */
            } else if (this.urlActual === '/' + RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.consult_worker.path + '?id=' + RoutingPath.appRouting.components.certificates.pages.worker_affiliation_certificate.id) {
              this._storage.stringifyItem(environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION, response.body.afiliado);
              this._router.navigate(['/' + RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.worker_affiliation_certificate.path + '/' + user.idTypePerson + '/' + user.idPerson], { relativeTo: this._route });
              /**
               * Valido si la url actual es consulta cuota monetaria trabajador
               */
            } else if (this.urlActual === '/' + RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.consult_worker.path + '?id=' + RoutingPath.appRouting.components.certificates.pages.search_monetary_fee.id) {
              this._storage.stringifyItem(environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION, response.body.afiliado);
              this._router.navigate(['/' + RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.search_monetary_fee.path + '/' + user.idTypePerson + '/' + user.idPerson], { relativeTo: this._route });
            }
          } else if (response.code.code === 201) {
            /**
             * Verifico si la url actual es de afiliacion uno a uno
             */
            if (this.urlActual === '/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path) {
              // this._localStorage.stringifyItem(environment.LOCAL_STORAGE.DATA_AFILIACION_USUARIO, response.body.afiliado);
              this._router.navigate(['/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.affiliation_form.path + '/' + user.idTypePerson + '/' + user.idPerson], { relativeTo: this._route });

              /**
               * Valido si la url actual es consulta de informacion trabajadores
               * Valido si la url actua es certificado consulta trabajador
               */
            } else if ((this.urlActual === '/' + RoutingPath.appRouting.components.workers_information.path + '/' + RoutingPath.appRouting.components.workers_information.pages.consult_worker.path) || (this.urlActual === '/' + RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.consult_worker.path + '?id=' + RoutingPath.appRouting.components.certificates.pages.worker_affiliation_certificate.id) || (this.urlActual === '/' + RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.consult_worker.path + '?id=' + RoutingPath.appRouting.components.certificates.pages.search_monetary_fee.id)) {
              this.noAffiliateCompany = true;
              this.validation = false;
            }
            else if (this.isAfiliadoDataEvent) {
              this.noAffiliateCompany = true;
              this.validation = false;
            }

          } else if (response.code.code === 404) {
            /**
             * Verifico si la url actual es de afiliacion uno a uno
             */
            if (this.urlActual === '/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path) {
              this._router.navigate(['/' + RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.affiliation_form.path + '/' + user.idTypePerson + '/' + user.idPerson], { relativeTo: this._route });
            } else {
              this.noAffiliateCompany = true;
              this.validation = false;
            }
          }
        }),
        catchError((err) => {
          this.processing = false;
          return err;
        })
      ).subscribe();
  }

  otherAffiliate() {
    this.validation = true;
    this.affiliation = false;
    this.noAffiliateCompany = false;
  }

  keyPressNumDoc(numDoc: string) {
    if (numDoc !== '') {
      this.numDocIsFill = true;
    } else {
      this.numDocIsFill = false;
    }
    this.validarDocumentoIgualEmpresa();
  }
  focusNext() {
    if (this.validateUserForm.valid && !this.processing) {
      const input: HTMLInputElement = this.btnConsultar?.nativeElement as HTMLInputElement;
      input?.focus();
    }
  }

private validarDocumentoIgualEmpresa(): void {

  const numeroTrabajador = this.validateUserForm.get('idPerson')?.value;
    if (!numeroTrabajador) {
      return;
    }

    const numeroEmpresa = String(this.companyData.docNumberCompany);
    const numeroEmpresaDigito = String(this.companyData.docNumberCompany)+""+String(this.companyData.checkDigit);

    if ((String(numeroTrabajador) === numeroEmpresa) || (String(numeroTrabajador) === numeroEmpresaDigito)) {

      this.validateUserForm
        .get('idPerson')
        ?.setErrors({ documentoIgualEmpresa: true });

      
      this._modalVariadoService.modalAlerta(
        'De acuerdo con lo estipulado en el "Articulo 22 del Código Sustantivo de Trabajo", ' +
        'para que exista una relación laboral se requiere una subordinación, y en su caso, ' +
        'usted como empleador(a) NO tiene la calidad de trabajador, debido a que no puede ser ' +
        'subordinado de sí mismo como empleador persona natural y a su vez trabajador. ' +
        'Si desea beneficiarse de los servicios que ofrece Colsubsidio, le sugerimos afiliarse ' +
        'como trabajador independiente, para lo cual deberá diligenciar el formulario que puede ' +
        'encontrar en la página www.colsubsidio.com.'
      );

    }
  }


}
